<template>
  <div class="filter-chips-wrapper">
    <v-chip
      :small="isMobile"
      :class="{ 'mobile-chip': isMobile }"
      link
      @click="$emit('show-date-dialog')"
    >
      <span :key="datesChipKey" class="chip-text">
        {{ datesChipText }}
      </span>
    </v-chip>
  </div>
</template>

<script>
import formattedDate from "@/mixins/formattedDate";
import isMobile from "@/mixins/isMobile";
import { addDays } from "date-fns";

export default {
  name: "ReportsToolbarDatesChip",
  mixins: [formattedDate, isMobile],
  props: {
    date: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      datesChipKey: 1,
    };
  },
  computed: {
    datesChipText() {
      let chipDateText =
        this.formattedDate(this.date, "dd DD MMM YYYY") +
        " ~ " +
        this.formattedDate(addDays(this.date, 6), "dd DD MMM YYYY");
      return chipDateText;
    },
  },
  watch: {
    date() {
      this.datesChipKey++;
    },
  },
};
</script>
